<span *ngFor="let publisherModel of publisherModels" class="publisherIconContainer">
	<img class="publisherIcon" src="{{ publisherModel.imageURL }}" *ngIf="publisherModel.imageURL" /> 
</span>